export default __webpack_public_path__ + "static/media/Group 3173@2x.d828f5b3.png";